import jQuery from 'jquery';
import jQueryDialog from 'jquery-ui/ui/widgets/dialog';
import jQueryUi from 'jquery-ui';

const defaultFn = function () {
	jQuery.widget( "ep.epDialog", jQuery.ui.dialog, {
		options: {
			resizable: false,
			modal: true,
			position: { my: 'center', at: 'center', 'of': $(window), collision: 'none'},
			dialogOpenClass: 'dialog-open',
			autoOpen: true
		},
		open: function(event, ui) {
			jQuery('body').addClass(this.options.dialogOpenClass);
			this._super(event, ui);
		},
		close: function(event, ui) {
			this._super(event, ui);
			
			jQuery('body').removeClass(this.options.dialogOpenClass);
		}
	});
}

export {defaultFn as default};